let userDataLocal = localStorage.getItem("userData");
var userDataParse = JSON.parse(userDataLocal);

const userData = userDataLocal
    ? userDataParse
    : {
          shop: "test-smartactivate.myshopify.com",
          accessToken: "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",
      };
export default userData;
